export const ADD_FUNCTIONS = "ADD_FUNCTIONS";

type FunctionAction = typeof ADD_FUNCTIONS

export interface FunctionPayload {
  type: FunctionAction
  data: any;
}
